var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 292,
    viewBox: "0 0 2 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.950105,
    y1: 1.58753,
    x2: 0.950092,
    y2: 290.942,
    stroke: "#848AA0",
    strokeWidth: 1.75366,
    strokeLinecap: "round",
    strokeDasharray: "4.13 4.13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDashed);
export default __webpack_public_path__ + "static/media/lineDashed.8b0892ea2a7805907161a9edd41678dd.svg";
export { ForwardRef as ReactComponent };